// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/backoffice/web/users/v1/profile.proto (package gdx.backoffice.web.users.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Timezone } from "../../../../common/v1/profile_pb.js";

/**
 * Possible user verification sources.
 *
 * @generated from enum gdx.backoffice.web.users.v1.VerifiedBy
 */
export enum VerifiedBy {
  /**
   * @generated from enum value: VERIFIED_BY_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: VERIFIED_BY_FACEBOOK = 1;
   */
  FACEBOOK = 1,

  /**
   * @generated from enum value: VERIFIED_BY_GOOGLE = 2;
   */
  GOOGLE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(VerifiedBy)
proto3.util.setEnumType(VerifiedBy, "gdx.backoffice.web.users.v1.VerifiedBy", [
  { no: 0, name: "VERIFIED_BY_INVALID" },
  { no: 1, name: "VERIFIED_BY_FACEBOOK" },
  { no: 2, name: "VERIFIED_BY_GOOGLE" },
]);

/**
 * Possible values for user's photo status.
 *
 * @generated from enum gdx.backoffice.web.users.v1.PhotoStatus
 */
export enum PhotoStatus {
  /**
   * @generated from enum value: PHOTO_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PHOTO_STATUS_MODERATION = 1;
   */
  MODERATION = 1,

  /**
   * @generated from enum value: PHOTO_STATUS_DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: PHOTO_STATUS_APPROVED = 3;
   */
  APPROVED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PhotoStatus)
proto3.util.setEnumType(PhotoStatus, "gdx.backoffice.web.users.v1.PhotoStatus", [
  { no: 0, name: "PHOTO_STATUS_INVALID" },
  { no: 1, name: "PHOTO_STATUS_MODERATION" },
  { no: 2, name: "PHOTO_STATUS_DECLINED" },
  { no: 3, name: "PHOTO_STATUS_APPROVED" },
]);

/**
 * Possible values for user gender in profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileGender
 */
export enum ProfileGender {
  /**
   * @generated from enum value: PROFILE_GENDER_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROFILE_GENDER_MALE = 1;
   */
  MALE = 1,

  /**
   * @generated from enum value: PROFILE_GENDER_FEMALE = 2;
   */
  FEMALE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileGender)
proto3.util.setEnumType(ProfileGender, "gdx.backoffice.web.users.v1.ProfileGender", [
  { no: 0, name: "PROFILE_GENDER_INVALID" },
  { no: 1, name: "PROFILE_GENDER_MALE" },
  { no: 2, name: "PROFILE_GENDER_FEMALE" },
]);

/**
 * Possible values for field "What is your physique?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileBodyType
 */
export enum ProfileBodyType {
  /**
   * @generated from enum value: PROFILE_BODY_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_BODY_TYPE_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_BODY_TYPE_SKINNY = 2;
   */
  SKINNY = 2,

  /**
   * @generated from enum value: PROFILE_BODY_TYPE_AVERAGE = 3;
   */
  AVERAGE = 3,

  /**
   * @generated from enum value: PROFILE_BODY_TYPE_ATHLETIC = 4;
   */
  ATHLETIC = 4,

  /**
   * @generated from enum value: PROFILE_BODY_TYPE_CURVY = 6;
   */
  CURVY = 6,

  /**
   * @generated from enum value: PROFILE_BODY_TYPE_BIG = 8;
   */
  BIG = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileBodyType)
proto3.util.setEnumType(ProfileBodyType, "gdx.backoffice.web.users.v1.ProfileBodyType", [
  { no: 0, name: "PROFILE_BODY_TYPE_INVALID" },
  { no: 1, name: "PROFILE_BODY_TYPE_EMPTY" },
  { no: 2, name: "PROFILE_BODY_TYPE_SKINNY" },
  { no: 3, name: "PROFILE_BODY_TYPE_AVERAGE" },
  { no: 4, name: "PROFILE_BODY_TYPE_ATHLETIC" },
  { no: 6, name: "PROFILE_BODY_TYPE_CURVY" },
  { no: 8, name: "PROFILE_BODY_TYPE_BIG" },
]);

/**
 * Possible values for field "Do you have children?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileChildren
 */
export enum ProfileChildren {
  /**
   * @generated from enum value: PROFILE_CHILDREN_INVALID = 0;
   */
  INVALID = 0,

  /**
   * When answer 'Ask me'.
   *
   * @generated from enum value: PROFILE_CHILDREN_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_CHILDREN_YES = 2;
   */
  YES = 2,

  /**
   * @generated from enum value: PROFILE_CHILDREN_NO = 3;
   */
  NO = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileChildren)
proto3.util.setEnumType(ProfileChildren, "gdx.backoffice.web.users.v1.ProfileChildren", [
  { no: 0, name: "PROFILE_CHILDREN_INVALID" },
  { no: 1, name: "PROFILE_CHILDREN_EMPTY" },
  { no: 2, name: "PROFILE_CHILDREN_YES" },
  { no: 3, name: "PROFILE_CHILDREN_NO" },
]);

/**
 * Possible values for field "Your religion" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileReligion
 */
export enum ProfileReligion {
  /**
   * @generated from enum value: PROFILE_RELIGION_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_RELIGION_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_RELIGION_CHRISTIANITY = 2;
   */
  CHRISTIANITY = 2,

  /**
   * @generated from enum value: PROFILE_RELIGION_ISLAM = 3;
   */
  ISLAM = 3,

  /**
   * @generated from enum value: PROFILE_RELIGION_HINDUISM = 5;
   */
  HINDUISM = 5,

  /**
   * @generated from enum value: PROFILE_RELIGION_BUDDHISM = 7;
   */
  BUDDHISM = 7,

  /**
   * @generated from enum value: PROFILE_RELIGION_JUDAISM = 8;
   */
  JUDAISM = 8,

  /**
   * @generated from enum value: PROFILE_RELIGION_AGNOSTICISM = 10;
   */
  AGNOSTICISM = 10,

  /**
   * @generated from enum value: PROFILE_RELIGION_ATHEISM = 11;
   */
  ATHEISM = 11,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileReligion)
proto3.util.setEnumType(ProfileReligion, "gdx.backoffice.web.users.v1.ProfileReligion", [
  { no: 0, name: "PROFILE_RELIGION_INVALID" },
  { no: 1, name: "PROFILE_RELIGION_EMPTY" },
  { no: 2, name: "PROFILE_RELIGION_CHRISTIANITY" },
  { no: 3, name: "PROFILE_RELIGION_ISLAM" },
  { no: 5, name: "PROFILE_RELIGION_HINDUISM" },
  { no: 7, name: "PROFILE_RELIGION_BUDDHISM" },
  { no: 8, name: "PROFILE_RELIGION_JUDAISM" },
  { no: 10, name: "PROFILE_RELIGION_AGNOSTICISM" },
  { no: 11, name: "PROFILE_RELIGION_ATHEISM" },
]);

/**
 * Possible values for field "Are you drinking?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileDrinking
 */
export enum ProfileDrinking {
  /**
   * @generated from enum value: PROFILE_DRINKING_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Ask me.
   *
   * @generated from enum value: PROFILE_DRINKING_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_DRINKING_SOCIALLY = 2;
   */
  SOCIALLY = 2,

  /**
   * @generated from enum value: PROFILE_DRINKING_A_LOT = 4;
   */
  A_LOT = 4,

  /**
   * @generated from enum value: PROFILE_DRINKING_NOT = 5;
   */
  NOT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileDrinking)
proto3.util.setEnumType(ProfileDrinking, "gdx.backoffice.web.users.v1.ProfileDrinking", [
  { no: 0, name: "PROFILE_DRINKING_INVALID" },
  { no: 1, name: "PROFILE_DRINKING_EMPTY" },
  { no: 2, name: "PROFILE_DRINKING_SOCIALLY" },
  { no: 4, name: "PROFILE_DRINKING_A_LOT" },
  { no: 5, name: "PROFILE_DRINKING_NOT" },
]);

/**
 * Possible values for field "Do you smoke?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileSmoking
 */
export enum ProfileSmoking {
  /**
   * @generated from enum value: PROFILE_SMOKING_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Ask me.
   *
   * @generated from enum value: PROFILE_SMOKING_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_SMOKING_SOCIALLY = 2;
   */
  SOCIALLY = 2,

  /**
   * @generated from enum value: PROFILE_SMOKING_A_LOT = 4;
   */
  A_LOT = 4,

  /**
   * @generated from enum value: PROFILE_SMOKING_NOT = 5;
   */
  NOT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileSmoking)
proto3.util.setEnumType(ProfileSmoking, "gdx.backoffice.web.users.v1.ProfileSmoking", [
  { no: 0, name: "PROFILE_SMOKING_INVALID" },
  { no: 1, name: "PROFILE_SMOKING_EMPTY" },
  { no: 2, name: "PROFILE_SMOKING_SOCIALLY" },
  { no: 4, name: "PROFILE_SMOKING_A_LOT" },
  { no: 5, name: "PROFILE_SMOKING_NOT" },
]);

/**
 * Possible values for field "Your orientation" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileSexualOrientation
 */
export enum ProfileSexualOrientation {
  /**
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_HETEROSEXUAL = 2;
   */
  HETEROSEXUAL = 2,

  /**
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_GAY = 3;
   */
  GAY = 3,

  /**
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_LESBIAN = 4;
   */
  LESBIAN = 4,

  /**
   * @generated from enum value: PROFILE_SEXUAL_ORIENTATION_BISEXUAL = 5;
   */
  BISEXUAL = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileSexualOrientation)
proto3.util.setEnumType(ProfileSexualOrientation, "gdx.backoffice.web.users.v1.ProfileSexualOrientation", [
  { no: 0, name: "PROFILE_SEXUAL_ORIENTATION_INVALID" },
  { no: 1, name: "PROFILE_SEXUAL_ORIENTATION_EMPTY" },
  { no: 2, name: "PROFILE_SEXUAL_ORIENTATION_HETEROSEXUAL" },
  { no: 3, name: "PROFILE_SEXUAL_ORIENTATION_GAY" },
  { no: 4, name: "PROFILE_SEXUAL_ORIENTATION_LESBIAN" },
  { no: 5, name: "PROFILE_SEXUAL_ORIENTATION_BISEXUAL" },
]);

/**
 * Possible values for field "What is your marital status?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileMaritalStatus
 */
export enum ProfileMaritalStatus {
  /**
   * @generated from enum value: PROFILE_MARITAL_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Ask me.
   *
   * @generated from enum value: PROFILE_MARITAL_STATUS_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_MARITAL_STATUS_SINGLE = 2;
   */
  SINGLE = 2,

  /**
   * @generated from enum value: PROFILE_MARITAL_STATUS_SEPARATED = 3;
   */
  SEPARATED = 3,

  /**
   * @generated from enum value: PROFILE_MARITAL_STATUS_DIVORCED = 4;
   */
  DIVORCED = 4,

  /**
   * @generated from enum value: PROFILE_MARITAL_STATUS_WIDOWED = 5;
   */
  WIDOWED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileMaritalStatus)
proto3.util.setEnumType(ProfileMaritalStatus, "gdx.backoffice.web.users.v1.ProfileMaritalStatus", [
  { no: 0, name: "PROFILE_MARITAL_STATUS_INVALID" },
  { no: 1, name: "PROFILE_MARITAL_STATUS_EMPTY" },
  { no: 2, name: "PROFILE_MARITAL_STATUS_SINGLE" },
  { no: 3, name: "PROFILE_MARITAL_STATUS_SEPARATED" },
  { no: 4, name: "PROFILE_MARITAL_STATUS_DIVORCED" },
  { no: 5, name: "PROFILE_MARITAL_STATUS_WIDOWED" },
]);

/**
 * Possible values for field "What are you looking?" in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileLookingFor
 */
export enum ProfileLookingFor {
  /**
   * @generated from enum value: PROFILE_LOOKING_FOR_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Ask me.
   *
   * @generated from enum value: PROFILE_LOOKING_FOR_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_LOOKING_FOR_TALK = 2;
   */
  TALK = 2,

  /**
   * @generated from enum value: PROFILE_LOOKING_FOR_FRIEND = 3;
   */
  FRIEND = 3,

  /**
   * @generated from enum value: PROFILE_LOOKING_FOR_DATING = 4;
   */
  DATING = 4,

  /**
   * @generated from enum value: PROFILE_LOOKING_FOR_MARRIAGE = 5;
   */
  MARRIAGE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileLookingFor)
proto3.util.setEnumType(ProfileLookingFor, "gdx.backoffice.web.users.v1.ProfileLookingFor", [
  { no: 0, name: "PROFILE_LOOKING_FOR_INVALID" },
  { no: 1, name: "PROFILE_LOOKING_FOR_EMPTY" },
  { no: 2, name: "PROFILE_LOOKING_FOR_TALK" },
  { no: 3, name: "PROFILE_LOOKING_FOR_FRIEND" },
  { no: 4, name: "PROFILE_LOOKING_FOR_DATING" },
  { no: 5, name: "PROFILE_LOOKING_FOR_MARRIAGE" },
]);

/**
 * Possible hair colors in user's profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileHairColor
 */
export enum ProfileHairColor {
  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_HAIR_COLOR_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_BLACK = 2;
   */
  BLACK = 2,

  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_BROWN = 3;
   */
  BROWN = 3,

  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_GINGER = 5;
   */
  GINGER = 5,

  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_BLONDIE = 6;
   */
  BLONDIE = 6,

  /**
   * @generated from enum value: PROFILE_HAIR_COLOR_SILVER = 7;
   */
  SILVER = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileHairColor)
proto3.util.setEnumType(ProfileHairColor, "gdx.backoffice.web.users.v1.ProfileHairColor", [
  { no: 0, name: "PROFILE_HAIR_COLOR_INVALID" },
  { no: 1, name: "PROFILE_HAIR_COLOR_EMPTY" },
  { no: 2, name: "PROFILE_HAIR_COLOR_BLACK" },
  { no: 3, name: "PROFILE_HAIR_COLOR_BROWN" },
  { no: 5, name: "PROFILE_HAIR_COLOR_GINGER" },
  { no: 6, name: "PROFILE_HAIR_COLOR_BLONDIE" },
  { no: 7, name: "PROFILE_HAIR_COLOR_SILVER" },
]);

/**
 * Possible eye colors in user's profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileEyeColor
 */
export enum ProfileEyeColor {
  /**
   * @generated from enum value: PROFILE_EYE_COLOR_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_EYE_COLOR_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_EYE_COLOR_BLUE = 2;
   */
  BLUE = 2,

  /**
   * @generated from enum value: PROFILE_EYE_COLOR_BROWN = 3;
   */
  BROWN = 3,

  /**
   * @generated from enum value: PROFILE_EYE_COLOR_GREEN = 4;
   */
  GREEN = 4,

  /**
   * @generated from enum value: PROFILE_EYE_COLOR_GRAY = 5;
   */
  GRAY = 5,

  /**
   * @generated from enum value: PROFILE_EYE_COLOR_HAZEL = 6;
   */
  HAZEL = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileEyeColor)
proto3.util.setEnumType(ProfileEyeColor, "gdx.backoffice.web.users.v1.ProfileEyeColor", [
  { no: 0, name: "PROFILE_EYE_COLOR_INVALID" },
  { no: 1, name: "PROFILE_EYE_COLOR_EMPTY" },
  { no: 2, name: "PROFILE_EYE_COLOR_BLUE" },
  { no: 3, name: "PROFILE_EYE_COLOR_BROWN" },
  { no: 4, name: "PROFILE_EYE_COLOR_GREEN" },
  { no: 5, name: "PROFILE_EYE_COLOR_GRAY" },
  { no: 6, name: "PROFILE_EYE_COLOR_HAZEL" },
]);

/**
 * Available height measure units.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileHeightUnits
 */
export enum ProfileHeightUnits {
  /**
   * @generated from enum value: PROFILE_HEIGHT_UNITS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROFILE_HEIGHT_UNITS_IN = 1;
   */
  IN = 1,

  /**
   * @generated from enum value: PROFILE_HEIGHT_UNITS_CM = 2;
   */
  CM = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileHeightUnits)
proto3.util.setEnumType(ProfileHeightUnits, "gdx.backoffice.web.users.v1.ProfileHeightUnits", [
  { no: 0, name: "PROFILE_HEIGHT_UNITS_INVALID" },
  { no: 1, name: "PROFILE_HEIGHT_UNITS_IN" },
  { no: 2, name: "PROFILE_HEIGHT_UNITS_CM" },
]);

/**
 * Available radius units.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileComfortRadiusUnits
 */
export enum ProfileComfortRadiusUnits {
  /**
   * @generated from enum value: PROFILE_COMFORT_RADIUS_UNITS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROFILE_COMFORT_RADIUS_UNITS_MI = 1;
   */
  MI = 1,

  /**
   * @generated from enum value: PROFILE_COMFORT_RADIUS_UNITS_KM = 2;
   */
  KM = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileComfortRadiusUnits)
proto3.util.setEnumType(ProfileComfortRadiusUnits, "gdx.backoffice.web.users.v1.ProfileComfortRadiusUnits", [
  { no: 0, name: "PROFILE_COMFORT_RADIUS_UNITS_INVALID" },
  { no: 1, name: "PROFILE_COMFORT_RADIUS_UNITS_MI" },
  { no: 2, name: "PROFILE_COMFORT_RADIUS_UNITS_KM" },
]);

/**
 * Available spheres of work in user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileSphereOfWork
 */
export enum ProfileSphereOfWork {
  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_AGRICULTURE = 1;
   */
  AGRICULTURE = 1,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_ARCHITECTURE = 2;
   */
  ARCHITECTURE = 2,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_ARTS = 3;
   */
  ARTS = 3,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_BUSINESS_MANAGEMENT = 4;
   */
  BUSINESS_MANAGEMENT = 4,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_EDUCATION = 5;
   */
  EDUCATION = 5,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_FINANCE = 6;
   */
  FINANCE = 6,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_GOVERNMENT = 7;
   */
  GOVERNMENT = 7,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_HEALTH = 8;
   */
  HEALTH = 8,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_TOURISM = 9;
   */
  TOURISM = 9,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_HUMAN_RESOURCES = 10;
   */
  HUMAN_RESOURCES = 10,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_IT = 11;
   */
  IT = 11,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_LAW = 12;
   */
  LAW = 12,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_MANUFACTURING = 13;
   */
  MANUFACTURING = 13,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_MARKETING = 14;
   */
  MARKETING = 14,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_SCIENCE = 15;
   */
  SCIENCE = 15,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_LOGISTICS = 16;
   */
  LOGISTICS = 16,

  /**
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_RETIRED = 17;
   */
  RETIRED = 17,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_SPHERE_OF_WORK_EMPTY = 18;
   */
  EMPTY = 18,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileSphereOfWork)
proto3.util.setEnumType(ProfileSphereOfWork, "gdx.backoffice.web.users.v1.ProfileSphereOfWork", [
  { no: 0, name: "PROFILE_SPHERE_OF_WORK_INVALID" },
  { no: 1, name: "PROFILE_SPHERE_OF_WORK_AGRICULTURE" },
  { no: 2, name: "PROFILE_SPHERE_OF_WORK_ARCHITECTURE" },
  { no: 3, name: "PROFILE_SPHERE_OF_WORK_ARTS" },
  { no: 4, name: "PROFILE_SPHERE_OF_WORK_BUSINESS_MANAGEMENT" },
  { no: 5, name: "PROFILE_SPHERE_OF_WORK_EDUCATION" },
  { no: 6, name: "PROFILE_SPHERE_OF_WORK_FINANCE" },
  { no: 7, name: "PROFILE_SPHERE_OF_WORK_GOVERNMENT" },
  { no: 8, name: "PROFILE_SPHERE_OF_WORK_HEALTH" },
  { no: 9, name: "PROFILE_SPHERE_OF_WORK_TOURISM" },
  { no: 10, name: "PROFILE_SPHERE_OF_WORK_HUMAN_RESOURCES" },
  { no: 11, name: "PROFILE_SPHERE_OF_WORK_IT" },
  { no: 12, name: "PROFILE_SPHERE_OF_WORK_LAW" },
  { no: 13, name: "PROFILE_SPHERE_OF_WORK_MANUFACTURING" },
  { no: 14, name: "PROFILE_SPHERE_OF_WORK_MARKETING" },
  { no: 15, name: "PROFILE_SPHERE_OF_WORK_SCIENCE" },
  { no: 16, name: "PROFILE_SPHERE_OF_WORK_LOGISTICS" },
  { no: 17, name: "PROFILE_SPHERE_OF_WORK_RETIRED" },
  { no: 18, name: "PROFILE_SPHERE_OF_WORK_EMPTY" },
]);

/**
 * Available human ethnicity for user profile.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileEthnicity
 */
export enum ProfileEthnicity {
  /**
   * @generated from enum value: PROFILE_ETHNICITY_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_ETHNICITY_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_EUROPEAN_AMERICAN = 2;
   */
  EUROPEAN_AMERICAN = 2,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_AFRICAN_AMERICAN = 3;
   */
  AFRICAN_AMERICAN = 3,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_HISPANIC_AMERICAN = 4;
   */
  HISPANIC_AMERICAN = 4,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_ASIAN_AMERICAN = 5;
   */
  ASIAN_AMERICAN = 5,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_AMERICAN_INDIAN = 6;
   */
  AMERICAN_INDIAN = 6,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_NATIVE_HAWAIIAN = 7;
   */
  NATIVE_HAWAIIAN = 7,

  /**
   * @generated from enum value: PROFILE_ETHNICITY_TWO_OR_MORE = 8;
   */
  TWO_OR_MORE = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileEthnicity)
proto3.util.setEnumType(ProfileEthnicity, "gdx.backoffice.web.users.v1.ProfileEthnicity", [
  { no: 0, name: "PROFILE_ETHNICITY_INVALID" },
  { no: 1, name: "PROFILE_ETHNICITY_EMPTY" },
  { no: 2, name: "PROFILE_ETHNICITY_EUROPEAN_AMERICAN" },
  { no: 3, name: "PROFILE_ETHNICITY_AFRICAN_AMERICAN" },
  { no: 4, name: "PROFILE_ETHNICITY_HISPANIC_AMERICAN" },
  { no: 5, name: "PROFILE_ETHNICITY_ASIAN_AMERICAN" },
  { no: 6, name: "PROFILE_ETHNICITY_AMERICAN_INDIAN" },
  { no: 7, name: "PROFILE_ETHNICITY_NATIVE_HAWAIIAN" },
  { no: 8, name: "PROFILE_ETHNICITY_TWO_OR_MORE" },
]);

/**
 * User's sport attitude.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileSport
 */
export enum ProfileSport {
  /**
   * @generated from enum value: PROFILE_SPORT_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: PROFILE_SPORT_PROFESSIONAL = 2;
   */
  PROFESSIONAL = 2,

  /**
   * @generated from enum value: PROFILE_SPORT_ACTIVE = 3;
   */
  ACTIVE = 3,

  /**
   * @generated from enum value: PROFILE_SPORT_SOMETIMES = 4;
   */
  SOMETIMES = 4,

  /**
   * @generated from enum value: PROFILE_SPORT_NEVER = 6;
   */
  NEVER = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileSport)
proto3.util.setEnumType(ProfileSport, "gdx.backoffice.web.users.v1.ProfileSport", [
  { no: 0, name: "PROFILE_SPORT_INVALID" },
  { no: 2, name: "PROFILE_SPORT_PROFESSIONAL" },
  { no: 3, name: "PROFILE_SPORT_ACTIVE" },
  { no: 4, name: "PROFILE_SPORT_SOMETIMES" },
  { no: 6, name: "PROFILE_SPORT_NEVER" },
]);

/**
 * User's educational background.
 *
 * @generated from enum gdx.backoffice.web.users.v1.ProfileEducation
 */
export enum ProfileEducation {
  /**
   * @generated from enum value: PROFILE_EDUCATION_INVALID = 0;
   */
  INVALID = 0,

  /**
   * Other.
   *
   * @generated from enum value: PROFILE_EDUCATION_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: PROFILE_EDUCATION_GRADUATE_SCHOOL = 2;
   */
  GRADUATE_SCHOOL = 2,

  /**
   * @generated from enum value: PROFILE_EDUCATION_HIGH_SCHOOL = 3;
   */
  HIGH_SCHOOL = 3,

  /**
   * @generated from enum value: PROFILE_EDUCATION_COLLEGE = 4;
   */
  COLLEGE = 4,

  /**
   * @generated from enum value: PROFILE_EDUCATION_BACHELOR_DEGREE = 6;
   */
  BACHELOR_DEGREE = 6,

  /**
   * @generated from enum value: PROFILE_EDUCATION_DOCTORAL_DEGREE = 7;
   */
  DOCTORAL_DEGREE = 7,

  /**
   * @generated from enum value: PROFILE_EDUCATION_MASTERS_DEGREE = 8;
   */
  MASTERS_DEGREE = 8,
}
// Retrieve enum metadata with: proto3.getEnumType(ProfileEducation)
proto3.util.setEnumType(ProfileEducation, "gdx.backoffice.web.users.v1.ProfileEducation", [
  { no: 0, name: "PROFILE_EDUCATION_INVALID" },
  { no: 1, name: "PROFILE_EDUCATION_EMPTY" },
  { no: 2, name: "PROFILE_EDUCATION_GRADUATE_SCHOOL" },
  { no: 3, name: "PROFILE_EDUCATION_HIGH_SCHOOL" },
  { no: 4, name: "PROFILE_EDUCATION_COLLEGE" },
  { no: 6, name: "PROFILE_EDUCATION_BACHELOR_DEGREE" },
  { no: 7, name: "PROFILE_EDUCATION_DOCTORAL_DEGREE" },
  { no: 8, name: "PROFILE_EDUCATION_MASTERS_DEGREE" },
]);

/**
 * Describes temp profile editable properties.
 *
 * @generated from message gdx.backoffice.web.users.v1.TempProfile
 */
export class TempProfile extends Message<TempProfile> {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string about = 3;
   */
  about = "";

  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.ProfileLookingFor looking_for = 4;
   */
  lookingFor: ProfileLookingFor[] = [];

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileGender gender = 5;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSphereOfWork sphere_of_work = 6;
   */
  sphereOfWork = ProfileSphereOfWork.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileEducation education = 7;
   */
  education = ProfileEducation.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileGender match_gender = 8;
   */
  matchGender = ProfileGender.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSexualOrientation sexual_orientation = 9;
   */
  sexualOrientation = ProfileSexualOrientation.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileMaritalStatus marital_status = 10;
   */
  maritalStatus = ProfileMaritalStatus.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileChildren children = 11;
   */
  children = ProfileChildren.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileEyeColor eye_color = 12;
   */
  eyeColor = ProfileEyeColor.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileHairColor hair_color = 13;
   */
  hairColor = ProfileHairColor.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileReligion religion = 14;
   */
  religion = ProfileReligion.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileBodyType body_type = 15;
   */
  bodyType = ProfileBodyType.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSport sport = 16;
   */
  sport = ProfileSport.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileDrinking drinking = 17;
   */
  drinking = ProfileDrinking.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSmoking smoking = 18;
   */
  smoking = ProfileSmoking.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileHeight height = 19;
   */
  height?: ProfileHeight;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileLocation location = 20;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.ProfilePhoto photos = 21;
   */
  photos: ProfilePhoto[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp birthday_time = 22;
   */
  birthdayTime?: Timestamp;

  /**
   * @generated from field: repeated string tags = 23;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<TempProfile>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.TempProfile";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "looking_for", kind: "enum", T: proto3.getEnumType(ProfileLookingFor), repeated: true },
    { no: 5, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 6, name: "sphere_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork) },
    { no: 7, name: "education", kind: "enum", T: proto3.getEnumType(ProfileEducation) },
    { no: 8, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 9, name: "sexual_orientation", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation) },
    { no: 10, name: "marital_status", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus) },
    { no: 11, name: "children", kind: "enum", T: proto3.getEnumType(ProfileChildren) },
    { no: 12, name: "eye_color", kind: "enum", T: proto3.getEnumType(ProfileEyeColor) },
    { no: 13, name: "hair_color", kind: "enum", T: proto3.getEnumType(ProfileHairColor) },
    { no: 14, name: "religion", kind: "enum", T: proto3.getEnumType(ProfileReligion) },
    { no: 15, name: "body_type", kind: "enum", T: proto3.getEnumType(ProfileBodyType) },
    { no: 16, name: "sport", kind: "enum", T: proto3.getEnumType(ProfileSport) },
    { no: 17, name: "drinking", kind: "enum", T: proto3.getEnumType(ProfileDrinking) },
    { no: 18, name: "smoking", kind: "enum", T: proto3.getEnumType(ProfileSmoking) },
    { no: 19, name: "height", kind: "message", T: ProfileHeight },
    { no: 20, name: "location", kind: "message", T: ProfileLocation },
    { no: 21, name: "photos", kind: "message", T: ProfilePhoto, repeated: true },
    { no: 22, name: "birthday_time", kind: "message", T: Timestamp },
    { no: 23, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TempProfile {
    return new TempProfile().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TempProfile {
    return new TempProfile().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TempProfile {
    return new TempProfile().fromJsonString(jsonString, options);
  }

  static equals(a: TempProfile | PlainMessage<TempProfile> | undefined, b: TempProfile | PlainMessage<TempProfile> | undefined): boolean {
    return proto3.util.equals(TempProfile, a, b);
  }
}

/**
 * Describes all full user profile information.
 *
 * @generated from message gdx.backoffice.web.users.v1.FullProfileInfo
 */
export class FullProfileInfo extends Message<FullProfileInfo> {
  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileGender gender = 1;
   */
  gender = ProfileGender.INVALID;

  /**
   * @generated from field: string about = 2;
   */
  about = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSphereOfWork sphere_of_work = 3;
   */
  sphereOfWork = ProfileSphereOfWork.INVALID;

  /**
   * @generated from field: string position = 4;
   */
  position = "";

  /**
   * @generated from field: repeated string interests = 5;
   */
  interests: string[] = [];

  /**
   * @generated from field: string birth_place = 6;
   */
  birthPlace = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileEducation education = 8;
   */
  education = ProfileEducation.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileReligion religion = 9;
   */
  religion = ProfileReligion.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSexualOrientation sexual_orientation = 10;
   */
  sexualOrientation = ProfileSexualOrientation.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileMaritalStatus marital_status = 11;
   */
  maritalStatus = ProfileMaritalStatus.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileEthnicity ethnicity = 12;
   */
  ethnicity = ProfileEthnicity.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileHeight height = 13;
   */
  height?: ProfileHeight;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileBodyType body_type = 15;
   */
  bodyType = ProfileBodyType.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileHairColor hair_color = 16;
   */
  hairColor = ProfileHairColor.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileChildren children = 17;
   */
  children = ProfileChildren.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileDrinking drinking = 19;
   */
  drinking = ProfileDrinking.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSmoking smoking = 20;
   */
  smoking = ProfileSmoking.INVALID;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileLocation location = 21;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: bool is_location_update_allowed = 22;
   */
  isLocationUpdateAllowed = false;

  /**
   * @generated from field: bool is_location_detection_allowed = 23;
   */
  isLocationDetectionAllowed = false;

  /**
   * @generated from field: string name = 25;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 26;
   */
  age = 0;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileGender match_gender = 27;
   */
  matchGender = ProfileGender.INVALID;

  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.ProfileLookingFor looking_for = 28;
   */
  lookingFor: ProfileLookingFor[] = [];

  /**
   * @generated from field: string user_id = 29;
   */
  userId = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileSport sport = 30;
   */
  sport = ProfileSport.INVALID;

  /**
   * @generated from field: string educational_institution = 31;
   */
  educationalInstitution = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileEyeColor eye_color = 32;
   */
  eyeColor = ProfileEyeColor.INVALID;

  /**
   * @generated from field: string raw_json = 33 [deprecated = true];
   * @deprecated
   */
  rawJson = "";

  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.ProfilePhoto photos = 34;
   */
  photos: ProfilePhoto[] = [];

  /**
   * @generated from field: gdx.common.v1.Timezone timezone = 35;
   */
  timezone?: Timezone;

  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.VerifiedBy verified_by = 36;
   */
  verifiedBy: VerifiedBy[] = [];

  /**
   * @generated from field: string currency = 37;
   */
  currency = "";

  constructor(data?: PartialMessage<FullProfileInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.FullProfileInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 2, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sphere_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork) },
    { no: 4, name: "position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "interests", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "birth_place", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "education", kind: "enum", T: proto3.getEnumType(ProfileEducation) },
    { no: 9, name: "religion", kind: "enum", T: proto3.getEnumType(ProfileReligion) },
    { no: 10, name: "sexual_orientation", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation) },
    { no: 11, name: "marital_status", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus) },
    { no: 12, name: "ethnicity", kind: "enum", T: proto3.getEnumType(ProfileEthnicity) },
    { no: 13, name: "height", kind: "message", T: ProfileHeight },
    { no: 15, name: "body_type", kind: "enum", T: proto3.getEnumType(ProfileBodyType) },
    { no: 16, name: "hair_color", kind: "enum", T: proto3.getEnumType(ProfileHairColor) },
    { no: 17, name: "children", kind: "enum", T: proto3.getEnumType(ProfileChildren) },
    { no: 19, name: "drinking", kind: "enum", T: proto3.getEnumType(ProfileDrinking) },
    { no: 20, name: "smoking", kind: "enum", T: proto3.getEnumType(ProfileSmoking) },
    { no: 21, name: "location", kind: "message", T: ProfileLocation },
    { no: 22, name: "is_location_update_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "is_location_detection_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 27, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender) },
    { no: 28, name: "looking_for", kind: "enum", T: proto3.getEnumType(ProfileLookingFor), repeated: true },
    { no: 29, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "sport", kind: "enum", T: proto3.getEnumType(ProfileSport) },
    { no: 31, name: "educational_institution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "eye_color", kind: "enum", T: proto3.getEnumType(ProfileEyeColor) },
    { no: 33, name: "raw_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "photos", kind: "message", T: ProfilePhoto, repeated: true },
    { no: 35, name: "timezone", kind: "message", T: Timezone },
    { no: 36, name: "verified_by", kind: "enum", T: proto3.getEnumType(VerifiedBy), repeated: true },
    { no: 37, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FullProfileInfo {
    return new FullProfileInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FullProfileInfo {
    return new FullProfileInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FullProfileInfo {
    return new FullProfileInfo().fromJsonString(jsonString, options);
  }

  static equals(a: FullProfileInfo | PlainMessage<FullProfileInfo> | undefined, b: FullProfileInfo | PlainMessage<FullProfileInfo> | undefined): boolean {
    return proto3.util.equals(FullProfileInfo, a, b);
  }
}

/**
 * Profile photo representation.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfilePhoto
 */
export class ProfilePhoto extends Message<ProfilePhoto> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gdx.backoffice.web.users.v1.PhotoStatus photo_status = 2;
   */
  photoStatus = PhotoStatus.INVALID;

  /**
   * @generated from field: string decline_reason = 3;
   */
  declineReason = "";

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<ProfilePhoto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfilePhoto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_status", kind: "enum", T: proto3.getEnumType(PhotoStatus) },
    { no: 3, name: "decline_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromJsonString(jsonString, options);
  }

  static equals(a: ProfilePhoto | PlainMessage<ProfilePhoto> | undefined, b: ProfilePhoto | PlainMessage<ProfilePhoto> | undefined): boolean {
    return proto3.util.equals(ProfilePhoto, a, b);
  }
}

/**
 * Geo location value representation used in user profile.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileLocation
 */
export class ProfileLocation extends Message<ProfileLocation> {
  /**
   * @generated from field: string country = 1;
   */
  country = "";

  /**
   * @generated from field: string city = 2;
   */
  city = "";

  /**
   * @generated from field: float latitude = 3;
   */
  latitude = 0;

  /**
   * @generated from field: float longitude = 4;
   */
  longitude = 0;

  /**
   * @generated from field: string state = 5;
   */
  state = "";

  constructor(data?: PartialMessage<ProfileLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "latitude", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "longitude", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLocation {
    return new ProfileLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLocation {
    return new ProfileLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLocation {
    return new ProfileLocation().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLocation | PlainMessage<ProfileLocation> | undefined, b: ProfileLocation | PlainMessage<ProfileLocation> | undefined): boolean {
    return proto3.util.equals(ProfileLocation, a, b);
  }
}

/**
 * User height value used in user profile.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileHeight
 */
export class ProfileHeight extends Message<ProfileHeight> {
  /**
   * @generated from field: int32 value = 1;
   */
  value = 0;

  /**
   * @generated from field: gdx.backoffice.web.users.v1.ProfileHeightUnits units = 2;
   */
  units = ProfileHeightUnits.INVALID;

  constructor(data?: PartialMessage<ProfileHeight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileHeight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "units", kind: "enum", T: proto3.getEnumType(ProfileHeightUnits) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileHeight {
    return new ProfileHeight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileHeight {
    return new ProfileHeight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileHeight {
    return new ProfileHeight().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileHeight | PlainMessage<ProfileHeight> | undefined, b: ProfileHeight | PlainMessage<ProfileHeight> | undefined): boolean {
    return proto3.util.equals(ProfileHeight, a, b);
  }
}

/**
 * Birthday value representation used in user profile.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileBirthday
 */
export class ProfileBirthday extends Message<ProfileBirthday> {
  /**
   * @generated from field: int32 day = 1;
   */
  day = 0;

  /**
   * @generated from field: int32 month = 2;
   */
  month = 0;

  /**
   * @generated from field: int32 year = 3;
   */
  year = 0;

  constructor(data?: PartialMessage<ProfileBirthday>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileBirthday";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileBirthday {
    return new ProfileBirthday().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileBirthday {
    return new ProfileBirthday().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileBirthday {
    return new ProfileBirthday().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileBirthday | PlainMessage<ProfileBirthday> | undefined, b: ProfileBirthday | PlainMessage<ProfileBirthday> | undefined): boolean {
    return proto3.util.equals(ProfileBirthday, a, b);
  }
}

/**
 * Describes field extra settings used during profile rendering.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileFieldSettings
 */
export class ProfileFieldSettings extends Message<ProfileFieldSettings> {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName = "";

  /**
   * @generated from field: bool is_locked = 2;
   */
  isLocked = false;

  constructor(data?: PartialMessage<ProfileFieldSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileFieldSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileFieldSettings {
    return new ProfileFieldSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileFieldSettings {
    return new ProfileFieldSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileFieldSettings {
    return new ProfileFieldSettings().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileFieldSettings | PlainMessage<ProfileFieldSettings> | undefined, b: ProfileFieldSettings | PlainMessage<ProfileFieldSettings> | undefined): boolean {
    return proto3.util.equals(ProfileFieldSettings, a, b);
  }
}

/**
 * Profile field for update request.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileField
 */
export class ProfileField extends Message<ProfileField> {
  /**
   * @generated from oneof gdx.backoffice.web.users.v1.ProfileField.field
   */
  field: {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileGender gender = 1;
     */
    value: ProfileGender;
    case: "gender";
  } | {
    /**
     * @generated from field: string about = 2;
     */
    value: string;
    case: "about";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileSphereOfWork sphere_of_work = 3;
     */
    value: ProfileSphereOfWork;
    case: "sphereOfWork";
  } | {
    /**
     * @generated from field: string position = 4;
     */
    value: string;
    case: "position";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileInterestRepeated interests = 5;
     */
    value: ProfileInterestRepeated;
    case: "interests";
  } | {
    /**
     * @generated from field: string birth_place = 6;
     */
    value: string;
    case: "birthPlace";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileEducation education = 8;
     */
    value: ProfileEducation;
    case: "education";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileReligion religion = 9;
     */
    value: ProfileReligion;
    case: "religion";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileSexualOrientation sexual_orientation = 10;
     */
    value: ProfileSexualOrientation;
    case: "sexualOrientation";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileMaritalStatus marital_status = 11;
     */
    value: ProfileMaritalStatus;
    case: "maritalStatus";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileEthnicity ethnicity = 12;
     */
    value: ProfileEthnicity;
    case: "ethnicity";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileHeight height = 13;
     */
    value: ProfileHeight;
    case: "height";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileBodyType body_type = 15;
     */
    value: ProfileBodyType;
    case: "bodyType";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileHairColor hair_color = 16;
     */
    value: ProfileHairColor;
    case: "hairColor";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileChildren children = 17;
     */
    value: ProfileChildren;
    case: "children";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileDrinking drinking = 19;
     */
    value: ProfileDrinking;
    case: "drinking";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileSmoking smoking = 20;
     */
    value: ProfileSmoking;
    case: "smoking";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileLocation location = 21;
     */
    value: ProfileLocation;
    case: "location";
  } | {
    /**
     * @generated from field: bool is_location_update_allowed = 22;
     */
    value: boolean;
    case: "isLocationUpdateAllowed";
  } | {
    /**
     * @generated from field: bool is_location_detection_allowed = 23;
     */
    value: boolean;
    case: "isLocationDetectionAllowed";
  } | {
    /**
     * @generated from field: string name = 24;
     */
    value: string;
    case: "name";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileGender match_gender = 25;
     */
    value: ProfileGender;
    case: "matchGender";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileLookingForRepeated looking_for = 26;
     */
    value: ProfileLookingForRepeated;
    case: "lookingFor";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileSport sport = 27;
     */
    value: ProfileSport;
    case: "sport";
  } | {
    /**
     * @generated from field: string educational_institution = 28;
     */
    value: string;
    case: "educationalInstitution";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileEyeColor eye_color = 29;
     */
    value: ProfileEyeColor;
    case: "eyeColor";
  } | {
    /**
     * @generated from field: gdx.backoffice.web.users.v1.ProfileBirthday birthday = 30;
     */
    value: ProfileBirthday;
    case: "birthday";
  } | {
    /**
     * @generated from field: string currency = 31;
     */
    value: string;
    case: "currency";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ProfileField>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileField";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gender", kind: "enum", T: proto3.getEnumType(ProfileGender), oneof: "field" },
    { no: 2, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 3, name: "sphere_of_work", kind: "enum", T: proto3.getEnumType(ProfileSphereOfWork), oneof: "field" },
    { no: 4, name: "position", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 5, name: "interests", kind: "message", T: ProfileInterestRepeated, oneof: "field" },
    { no: 6, name: "birth_place", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 8, name: "education", kind: "enum", T: proto3.getEnumType(ProfileEducation), oneof: "field" },
    { no: 9, name: "religion", kind: "enum", T: proto3.getEnumType(ProfileReligion), oneof: "field" },
    { no: 10, name: "sexual_orientation", kind: "enum", T: proto3.getEnumType(ProfileSexualOrientation), oneof: "field" },
    { no: 11, name: "marital_status", kind: "enum", T: proto3.getEnumType(ProfileMaritalStatus), oneof: "field" },
    { no: 12, name: "ethnicity", kind: "enum", T: proto3.getEnumType(ProfileEthnicity), oneof: "field" },
    { no: 13, name: "height", kind: "message", T: ProfileHeight, oneof: "field" },
    { no: 15, name: "body_type", kind: "enum", T: proto3.getEnumType(ProfileBodyType), oneof: "field" },
    { no: 16, name: "hair_color", kind: "enum", T: proto3.getEnumType(ProfileHairColor), oneof: "field" },
    { no: 17, name: "children", kind: "enum", T: proto3.getEnumType(ProfileChildren), oneof: "field" },
    { no: 19, name: "drinking", kind: "enum", T: proto3.getEnumType(ProfileDrinking), oneof: "field" },
    { no: 20, name: "smoking", kind: "enum", T: proto3.getEnumType(ProfileSmoking), oneof: "field" },
    { no: 21, name: "location", kind: "message", T: ProfileLocation, oneof: "field" },
    { no: 22, name: "is_location_update_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
    { no: 23, name: "is_location_detection_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "field" },
    { no: 24, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 25, name: "match_gender", kind: "enum", T: proto3.getEnumType(ProfileGender), oneof: "field" },
    { no: 26, name: "looking_for", kind: "message", T: ProfileLookingForRepeated, oneof: "field" },
    { no: 27, name: "sport", kind: "enum", T: proto3.getEnumType(ProfileSport), oneof: "field" },
    { no: 28, name: "educational_institution", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 29, name: "eye_color", kind: "enum", T: proto3.getEnumType(ProfileEyeColor), oneof: "field" },
    { no: 30, name: "birthday", kind: "message", T: ProfileBirthday, oneof: "field" },
    { no: 31, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileField {
    return new ProfileField().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileField {
    return new ProfileField().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileField {
    return new ProfileField().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileField | PlainMessage<ProfileField> | undefined, b: ProfileField | PlainMessage<ProfileField> | undefined): boolean {
    return proto3.util.equals(ProfileField, a, b);
  }
}

/**
 * User's interests wrapper, because of we can't use 'repeated' with 'oneof'.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileInterestRepeated
 */
export class ProfileInterestRepeated extends Message<ProfileInterestRepeated> {
  /**
   * @generated from field: repeated string interests = 1;
   */
  interests: string[] = [];

  constructor(data?: PartialMessage<ProfileInterestRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileInterestRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "interests", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileInterestRepeated {
    return new ProfileInterestRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileInterestRepeated | PlainMessage<ProfileInterestRepeated> | undefined, b: ProfileInterestRepeated | PlainMessage<ProfileInterestRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileInterestRepeated, a, b);
  }
}

/**
 * User's looking for wrapper.
 *
 * @generated from message gdx.backoffice.web.users.v1.ProfileLookingForRepeated
 */
export class ProfileLookingForRepeated extends Message<ProfileLookingForRepeated> {
  /**
   * @generated from field: repeated gdx.backoffice.web.users.v1.ProfileLookingFor lookings_for = 1;
   */
  lookingsFor: ProfileLookingFor[] = [];

  constructor(data?: PartialMessage<ProfileLookingForRepeated>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.backoffice.web.users.v1.ProfileLookingForRepeated";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lookings_for", kind: "enum", T: proto3.getEnumType(ProfileLookingFor), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLookingForRepeated {
    return new ProfileLookingForRepeated().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLookingForRepeated | PlainMessage<ProfileLookingForRepeated> | undefined, b: ProfileLookingForRepeated | PlainMessage<ProfileLookingForRepeated> | undefined): boolean {
    return proto3.util.equals(ProfileLookingForRepeated, a, b);
  }
}

